import enLocale from "element-ui/lib/locale/lang/en";
import { performanceEn } from "../temp/performance-en";
import trans from "@/doc/lang/_en.json";
import hom from "@/doc/hom/_en.json";
import { langEn } from "../lgyLangs/en";
import { fhbLangEn } from "../fhbLangs/en";
import { lssLangEn } from "../lssLangs/en";
import { wrhLangEn } from "../wrhLangs/en";
import { lxyLangEn } from "../lxyLangs/en";
import { DyLangEn } from "../DyLangs/en";


const en = {
  normal: "Normal",
  outsourcing: "Outsourcing",
  English: "English",
  española: "Spanish",
  India: "Hindi",
  authority: {
    createNewUser: "Create new user",
    enterName: "Enter name",
    enterEmail: "Enter email ",
    enterRole: "Enter role ",
    enterCountry: "Enter country ",
    enterID: "Enter id ",
    enterPassword: "Enter password ",
    password: "Password ",
    modifyPassword: "Modify password",
    oldPassword: "Old password",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    confirmTheChanges: "Confirm changes",
    ifForgotContactLeader: "Pls contact your leader if you forgot the password",
    disaccordWithThFirsPassword: "disaccord with the first password",
    passwordRules:
      "Password should contain uppercase and lowercase letters, numbers and symbols, don’t contain username, and 8 characters at least.",
    name: "Name",
    email: "Email",
    role: "Role",
    country: "Country",
    operator: "Operator",
    operate: "operate",
    Disable: "Disable",
    Enable: "Enable",
    enableGoogleVerification: "Enable google verification",
    requiredFields: "Required fields",
    pleaseFillInCorrectly: "Please fill in correctly",
    edit: "Edit",
    delete: "Delete",
    add: "Add",
    confirmDelete: "Confirm delete",
    cancel: "Cancel",
    ok: "Ok",
    search: "Aggregate Search",
    operateTime: "Operate time",
    roleManagement: "Role management",
    containsSubordinateLevelsAndCannotBeDeleted:
      "Contains subordinate levels and cannot be deleted",
    addaFirstLevelRole: "Add a first level role",
    roleRightsManagement: "Role rights management",
    permissionAssignment: "Permission assignment",
    operationAuthority: "Operation authority",
    dataAuthority: "Data authority",
    pleaseEnteraKeyword: "Please enter a keyword",
    passwordVerification: "Password verification",
    passwordDoesNotContainCapitalLettersPleaseFillInAgain:
      "Password does not contain capital letters please fill in again",
    passwordDoesNotContainLowercaseLettersPleaseFillInAgain:
      "Password does not contain lowercase letters please fill in again",
    thePasswordDoesNotContainNumbersPleaseFillInAgain:
      "The password does not contain numbers please fill in again",
    passwordDoesNotContainCharactersPleaseFillInAgain:
      "Password does not contain characters please fill in again",
    cantUseYourNameAsPasswordPleaseFillInAgain:
      "Cant use your name as password please fill in again",
    repeatPasswordPleaseFillInAgain: "Repeat password please fill in again",
    disaccordWithTheFirstPassword: "disaccord with the first password",
    mailboxAlreadyExistsPleaseFillInAgain:
      "Mailbox already exists please fill in again",
    theRoleContainsUsersAndCannotBeDeleted:
      "The role contains users and cannot be deleted",
    roleGroupManagement: "Role group management",
    roleGroup: "Role group",
    createGroup: "Create group",
    groupRoleAddedSuccessfully: "Group role added successfully",
    roleExistsInRoleGroupDeletionFailed:
      "Role exists in role group deletion failed",
    groupPermissionManagement: "Group permission management",
    permissionAssignmentSucceeded: "Permission assignment succeeded"
  },
  collectWorkOrders: {
    ticketAttributeConfiguration: "Ticket attribute configuration",
    singlePeriodDays: "Single period days",
    installmentDays: "Installment days",
    delete: "Delete",
    save: "Save",
    addCustomWorkOrderLevels: "Add custom work order levels",
    areYouSureToDelete: "Are you sure to delete",
    cancel: "Cancel",
    confirm: "Confirm",
    deleteAll: "Deleteall",
    edit: "Edit",
    pleaseSetaCoherentLevel: "Please seta coherent level",
    pleaseSetaDifferentLevel: "Please seta different level"
  },
  performance: {
    rollfinishnum: 'Roll Finish Num',
    staffPerformance: "Staff performance",
    ticketCategory: "Ticket category",
    role: "Role",
    time: "Time",
    staff: "Name",
    email: "Email",
    search: "Search",
    clear: "Clear",
    refresh: "Refresh",
    export: "Export",
    date: "Date",
    ranking: "Ranking",
    totalLeftUnpaidPrincipal: "Total amount",
    repayPrincipal: "Repay principal",
    repayInterest: "Repay interest",
    totalRepayAmount: "Total repay amount",
    repayRate: "Repay rate",
    targetRepayRate: "Target repay rate",
    diffTargetRepayAmount: "Diff target repay amount",
    newAssignNum: "New assign num",
    handleTimes: "Handle times",
    handleNum: "Handle num",
    completeNum: "Complete num",
    loadNum: "Load num",
    performanceComparison: "Performance comparison",
    type: "Type",
    belongedGroup: "Belonged group",
    staffOptional: "Staff optional",
    pleaseChoose: "Please choose",
    YesNoLastorderrule: "Yes no last order rule",
    byStaff: "By staff",
    byGroup: "By role",
    byGroup1: "By role",
    byGroup2: "By group",
    byGroup3: "OM",
    pleaseChooseARole: "Please choose a role",
    noStaffsUnderThisGroupWereFoundPleaseConfirmWhetherTheGroupAndStaffMatches:
      "No staffs under this group were found please confirm whether the group and staff matches",
    dashboard: "Dashboard",
    groupTotalRepayAmount: "Group total repay amount",
    groupRepayRate: "Group repay rate",
    groupKPI: "Group KPI",
    groupCompleteNum: "Group complete num",
    groupRanking: "Group ranking",
    group: "Group",
    staffRanking: "Staff ranking",
    name: "Name",
    newTab: "New tab",
    extensionFeeToNewOrde: "Extension Fee To New Order",
    numberApplicationsRolloverOrders:'Number of applications for rollover orders',
    totalExtensionRepaymentAmount: "Total Extension Repayment Amount",
    waiveOffAmount: "Waive Off Amount",
    waiveOffNum: "Waive Off Num",
    bonusAmount: "Bonus",
    completeLabel: "Performance completed",
    completed: "Completed",
    inCompleted: "InCompleted",
    repayAmount: 'Repay amount',
    repayTime: 'Bank entry time',
    notifyTime: 'Bank notice time',
    jsIndex: 'Serial number',
    businessTime: 'Business party notification time',
    answerNum: 'Number of connected call',
    answerTimes: 'Connect times',
    pstClosureNum: 'Number of ticket transcations',
    closureAmount: 'Finish amount',
    pstClosureAmount: 'Finish amount of ticket transcations',
    conversionRate: 'Conversion efficiency',
    closureRate: 'Finish rate',
    closureNum: 'Finish volume'
  },
  performance2: {
    bucket: "Bucket",
    fecha: "Date",
    avgcalltime: "Avg Call Times",
    difcalltime: "Dif Call Times",
    avgrepayrate: "Avg Repay Rate",
    hourlyachievementsents: "Hourly Achievements Ents",
    totalallocationamount: "Total Allocation Amount",
    totalrepayamount: "Total Repay amount",
    hourlytarget: "Hourly Target",
    completerate: "Complete Rate"
  },
  orderInfo: {
    BadDebts: "Bad debts",
  },
  ticket: {
    normal:'normal',
    abnormal:'abnormal',
    PowerNuclearRemarks: "Power Nuclear Remarks",
    PaymentCodeStatus: "Payment code status",
    PaymentCode: "Payment code",
    PaymentCodeAmount: "Payment code amount",
    ThirdPartyName: "Third party name",
    Mobile: "Mobile",
    VA: "VA",
    OXXOCode: "OXXO Code",
    PaynetCode: "Paynet Code",
    AccountId: "Account id",
    InvalidTime: "Invalid Time",
    RemainingAmount: "Remaining amount due",
    collectTicketSystem: "Collect ticket system",
    systemManager: "System manager",
    ticketID: "Ticket id",
    loanID: "Loan id",
    userID: "User id",
    caseID: "Case id",
    ticketAssignToName: "Ticket assign to name",
    ticketAssignToId: "Ticket assign to id",
    ticketCreateTime: "Ticket create time",
    completeTime: "Complete time",
    closeTime: "Close time",
    phoneSaleTag: "phoneSale tag",
    assignTime: "Assign time",
    ticketStatus: "Ticket status",
    orderStatus: "Order status",
    ticketCategory: "Ticket category",
    search: "Search",
    batchAssign: "Batch assign",
    emailNameExport: "Email List Export",
    batchRecover: "Batch recover",
    batchOutsourcing: "Batch outsourcing",
    batchRecall: "Batch Taking Back for Self Collection",
    dataExport: "Data export",
    manualUpgrade: "Manual Upgrade",
    handleTime: "Handle time",
    lastCommunicationResult: "Last communication result",
    nextCommunicationResult: "Next communication result",
    partialCompleteTime: "Partial complete time",
    expirationTime: "Expiration time",
    operation: "Operation",
    attributeConfigure: "Attribute configure",
    ticketBasicAttribute: "Ticket basic attribute",
    attributeNumber: "Attribute number",
    attributeName: "Attribute name",
    foundTime: "create Time",
    ticketCombineAttribute: "Ticket combine attribute",
    newAttributeValueOperation: "New attribute value operation",
    newCombineAttributeOperation: "New combine attribute operation",
    combineName: "Combine name",
    attributeOne: "Attribute one",
    calculate: "Calculate",
    value: "Value",
    attributeDetails: "Attribute details",
    updateTime: "Update time",
    edit: "Edit",
    loadAttributeConfigure: "Load attribute configure",
    loadAttributeName: "Load attribute name",
    attributeType: "Attribute type",
    combineAttributeNumber: "Combine attribute number",
    attributeValue: "Attribute value",
    newTicket: "New ticket",
    oldTicket: "Old ticket",
    completeTicket: "Complete ticket",
    telephone: "Telephone",
    customerName: "Customer name",
    dailyCollectionTimes: "Daily collection times",
    collectionTimes: "Collection times",
    lastCollectionTime: "Last collection time",
    lastCollectionRecord: "Last collection record",
    promiseToPayTime: "Promise to pay time",
    customerType: "Customer type",
    overdueDays: "Overdue days",
    timeSinceLastProcessing: "Time since last processing",
    collection: "Collection",
    ticketInfo: "Ticketinfo",
    warning: "Under Investigation. Stop calling to this customer!",
    LatestPromisedRepaymentTime: "Latest promised repayment time",
    customerDetailInformation: "Customer detail information",
    SMS: "SMS",
    SMSContext: "SMS context",
    sendMessageToCustomer: "Send message to customer",
    sendMessageToCustomer2: "Send message to me 2",
    sendMessageToContactOne: "Send message to contact one",
    sendMessageToContactTwo: "Send message to contact two",
    sendMessageToContactThree: "Send message to contact three",
    selectMessage: "Select message",
    selectWAMessage: "Select template",
    paymentlink: 'paymentLink',
    send: "Send",
    phone: "Phone",
    phoneTwo: "Second phone number",
    contact1phone: "Contact1phone",
    relationship: "Relationship",
    name: "Name",
    contact2phone: "Contact 2 phone",
    contact3phone: "Contact 3 phone",
    familyPhone: "Family phone",
    autoCallResult: "Auto call result",
    logCollectionDetails: "Log collection details",
    relief: "Relief",
    contactWay: "Contact way",
    contactTime: "Contact time",
    targetContact: "Target contact",
    connection: "Connection",
    willingnessToPay: "Willingness to pay",
    overdueReason: "Overdue reason",
    ticketTag: "ticket Tag",
    collectionResult: "Collection result",
    remark: "Remark",
    saveCollectionDetail: "Save collection detail",
    repaymentInfo: "Repayment info",
    VAaccount: "Va account",
    OXXOMarketPaymentCode: "OXXO market payment code",
    PaymentMarketPaymentCode: "Payment market payment code",
    remainingAmountDue: "Remaining amount due",
    marketPayAmount: "Market pay amount",
    OXXOMarketPaymentCodeAmount: "OXXO market payment code amount",
    PaymentMarketPaymentCodeAmount: "Payment market payment code amount",
    refreshOXXOMarketPaymentCode: "Refresh market payment code",
    rcrefreshOXXOMarketPaymentCode: "repayment request",
    refreshOXXOMarketPaymentCodeen: "Refresh partial payment code",
    GetReference: 'Get reference',
    OXXONeedFee: "OXXO need fee",
    PaynetNeedFee: "Paynet need fee",
    PaycashNeedFee: "Paycash need fee",
    PaymentNeedFee: "Payment need fee",
    BalotoNeedFee: "Vía Baloto need fee",
    EfectyNeedFee: "Efecty need fee",
    HandlingFee: "The repayment amount here does not include the repayment processing fee and IVA fee. Please check the repayment processing fee and IVA fee  on the ticket page after updating.",
    LoanInfo: "Loan info",
    SuggestInfo: "Recommended information",
    RemainingAmountDue: "Remaining amount due",
    OverdueDays: "Overdue days",
    ActualRepaymentAmount: "Actual repayment amount",
    TotalRepaymentAmount: "Total repayment amount",
    CollectionStaff: "Collection staff",
    TargetContact: "Target contact",
    CommunicationTools: "Communication tools",
    Contact: "Contact",
    ContactTime: "Contact time",
    answerTime: "Answer time",
    endTime: "end time",
    hangupDirection: "Hangup direction",
    hangupCause: "Hangup cause",
    isNotConnect: "Is not connect",
    PromiseToPayTime: "Promise to pay time",
    WillingnessToRepay: "Willingness to repay",
    CollectionResult: "Collection result",
    record: "Record",
    DueDate: "Due date",
    Principal: "Principal",
    ReceivedRepaymentOfPrincipal: "Received repayment of principal",
    GracePeriodInterest: "Grace period interest",
    ReceivedRepaymentOfGracePeriodInterest:
      "Received repayment of grace period interest",
    PenaltyAndExtraFeesThatShouldBePaid:
      "Penalty and extra fees that should be paid",
    ReceivedRepaymentOfPenalty: "Received repayment of penalty",
    autoCallTime: "Auto call time",
    Nickname: "Nickname",
    OnlineOrNot: "Online or not",
    UnprocessedTime: 'Unprocessed time',
    Hour: 'hour',
    MIN: 'min',
    LastTimeWork: 'Last time work tickets processed',
    AreYouSure: "Are you sure",
    Sure: "Sure",
    Cancel: "Cancel",
    DeductionOfPrincipal: "Deduction of principal",
    InterestReduction: "Interest reduction",
    RecordCollectionResults: "Record collection results",
    Connect: "Connect",
    NotConnected: "Not connected",
    LoanOrderNumber: "Loan order number",
    BillId: "Bill id",
    Collection: "Collection",
    RepaymentPlan: "Repay plan",
    AutomaticOutgoingCallRecord: "Automatic outgoing call record",
    Robotcallrecords: "Robot call records",
    PaymentRecord: "Payment Record",
    RecordCollectionRecord: "Record collection record",
    RepaymentIssueReport: "Repayment issue report",
    ApplyForInterestFreeze: "Apply for an interest freeze",
    CommitmentRepaymentTime: "Commitment repayment time",
    Reminder: "Reminder",
    CallObject: "Call object",
    CollectionMethod: "Collection method",
    ContactNumber: "Contact number",
    PhoneCallTime: "Phone call time",
    ResponseTime: "Response time",
    EndTime: "end time",
    OnhookDirection: "Onhook direction",
    ReasonForHangingUp: "Reason for hanging up",
    WhetherToDial: "Whether to dial",
    ReasonForNotReturning: "Reason for not returning",
    ReasonForNotConnecting: "Reason for not connecting",
    Result: "Result",
    Recording: "Recording",
    AutomaticOutgoingTime: "Automatic outgoing time",
    WhetherToCommunicate: "Whether to communicate",
    EnterThePartialRepaymentAmount: "Enter the partial repayment amount",
    Attention: "Attention",
    RemainingAmountOfTheOrder: "Remaining amount of the order",
    OrderId: "Orderid",
    ActualPaymentDate: "Actual payment date",
    ActualRepaymentPrincipal: "Actual repayment principal",
    RemissionDay: "Remission day",
    ReferralDirector: "Referral director",
    TheRemainingPrincipalCanBeReduced: "The remaining principal can be reduced",
    Reason: "Reason",
    ActualInterestPaidDuringGracePeriod:
      "Actual Interest paid during grace period",
    PenaltyInterestActuallyPaid: "Penalty interest actually paid",
    GracePeriodInterestRemissiond: "Grace period interest remissiond",
    RemissiondPenaltyInterest: "Remissiond penalty interest",
    TheRemainingPenaltyInterestCanBeRemission:
      "The remaining penalty interest can be remission",
    RemissionOfGracePeriodInterest: "Remission of grace period interest",
    RemainingDeductibleInterestFromTheGracePeriod:
      "Remaining deductible interest from the grace period",
    auditResults: "audit results",
    auditor: "auditor",
    ticketHandleTime: "ticket handle time",
    ticketCompleteTime: "ticket complete Time",
    closeReason: "close reason",
    viewTicket: "view ticket",
    repayStatus: "Reporting status",
    repayStatus0: "The repayment problem needs to be handled by CS",
    repayStatus1: "Waiting for bank / third party verification",
    repayStatus2: "Uploadable repayment problem",
    tryCalc: "Try Calc",
  },
  Dialer: {
    userName: "User name",
    extnumber: "Extnumber",
    assignStatus: "Assign status",
    assigned: "Assigned",
    unassigned: "Unassigned",
    assign: "assign",
    assignHistory: "assign history",
    supplier: "Supplier",
    InquiryExtensionNumberStartRange: "Inquiry extension number start range",
    InquiryExtensionNumberEndRange: "Inquiry extension number end range",
    AccountNumberStartRange: "Account number start range",
    AccountNumberEndRange: "Account number end range",
    addTime: "Add time",
    addTheExtensionNumber: "Add the extension number",
    deleteExtensionNumber: "Delete extension number",
    submit: "Submit",
    roleList: "Role list",
    unassign: "Unassign",
    assignStaff: "Assign staff",
    staffID: "Employee id",
    assignTime: "Assign time",
    unassignTime: "Unassign time",
    calledNumber: "Dest Num",
    explicitNumber: "Showing Num",
    Thelabelofintent: "The label of intent",
    creationTime: "Create Time",
    outboundTime: "Calling Time",
    outboundChannels: "Call channel",
    talkTime: "Call Duration",
    Callrecorddetails: "Call record details",
  },
  systemAttribute: {
    attributeName: "Attribute name",
    attributeDescription: "Attribute description",
    parameterValue: "Parameter value",
    submit: "Submit",
    NewSystemParameters: "New system parameters",
  },
  phoneVerify: {
    workStatus: "Work Status",
    isAttendance: "whetherAttendance",
    batchOperations: "Batch Operations",
    orderTime: "start time",
    PVCommissioner: "Phone Verify commissioner",
    IRCommissioner: "Info review commissioner",
    batchOrders: "Batch orders",
    batchStopOrders: "Batch stop orders",
    stopAcceptTicket: "Stop Accept Ticket",
    continueAcceptTicket: "Continue Accept Ticket"
  },
  userInfo: {
    identityInformation: "Identity information",
    name: "Name",
    gender: "Gender",
    IDType: "Id type",
    IDNumber: "Id number",
    mobileNumber: "Mobile number",
    email: "Email",
    versionName: "Version name",
    versionCode: "Version code",
    imageData: "Image data",
    IDPhoto: "Id photo",
    handheldPhoto: "Handheld photo",
    otherInformation: "Other information",
    personalInformation: "Personal information",
    marriageStatus: "Marriage status",
    birthday: "Birthday",
    numberOfChildren: "Number of children",
    currentAddress: "Current address",
    detailAddress: "Detail address",
    educationStatus: "Education status",
    familyPhone: "Family phone",
    disbursementType: "Disbursement type",
    bankName: "Bank name",
    bankNumber: "Bank number",
    workInformation: "Work information",
    workType: "Work type",
    monthlyIncome: "Monthly income",
    lengthOfWork: "Length of work",
    companyPhoneNumber: "Company phone number",
    companyName: "Company name",
    companyAddress: "Company address",
    salaryDay: "Salary day",
    contactInformation: "Contact information",
    contact1Name: "Contact1 name",
    contact1Relationship: "Contact1 relationship",
    phone: "Phone",
    contact2Name: "Contact 2 name",
    contact2Relationship: "Contact 2 relationship",
    communicationTime: "Communication time",
    communicator: "Communicator",
    contents: "Contents",
    remark: "Remark",
    loanHistory: "Loan history",
    loanAmount: "Loan amount",
    loanTerms: "Loan terms",
    loanStatus: "Loan status",
    applyTime: "Apply time",
    processingTime: "Processing time",
    loanTime: "Loan time",
    amountNumber: "Loan amount",
    closingTime: "Closing time",
    overdueDays: "Overdue days",
    ChangeHistory: "Change history",
    BorrowingHistory: "Borrowing history",
    AccountNumber: "Account number",
    UpdateItems: "Update items",
    OriginalValue: "Original value",
    TheCurrentValue: "The current value",
    TimeChange: "Time change",
    ModifiedBy: "Modified by",
    TheTerm: "The term",
    State: "State",
    BillingMessage: "Billing message"
  },
  menu: {
    PaymentCodeList: "Payment Code List",
    PaymentCodeHistory: "historic payment code",
    AuthoritySystem: "Authority system",
    UserManagement: "User management",
    RoleManagement: "Role management",
    AuthorityManagement: "Authority management",
    RolegroupManagement: "Rolegroup management",
    GroupRightsManagement: "Group rights management",
    SystemParameterConfiguration: "System parameter configuration",
    PhoneVerifySystem: "Information Auditing Management",
    StaffManagement: "Staff Management",
    QuestionLibraryConfig: "Audit Question Library Configuration",
    CaseClassification: "Case classification",
    CollectTicketSystem: "Collect ticket system",
    TicketManage: "Ticket Management",
    AttributeConfigure: "Attribute configure",
    TicketBasicAttribute: "Ticket basic attribute",
    TicketCombineAttribute: "Ticket combine attribute",
    LoadAttributeConfigure: "Load attribute configure",
    RuleConfiguration: "Rule configuration",
    GenerationRule: "Generation rule",
    DistributionRules: "Distribution rules",
    RecyclingRules: "Recycling rules",
    OutsourcingRules: "Outsourcing rules",
    WorkOrderProcessingList: "Work order processing list",
    QualityInspectionRecording:'Recording quality inspection work order management',
    Collection: "Collection",
    RecordingQuality:'Recording quality inspection list',
    RepaymentReminder: "Repayment reminder",
    DialerManagement: "Dialer management",
    VoipManagement: "Voip management",
    NxManagement: "Nx configuration",
    ExtensionManagement: 'Extension Management',
    PerformanceManagement: "Performance management",
    PersonalPerformance: "Personal performance",
    PersonalPerformance2: "Hourly Collection Data",
    PerformanceComparison: "Performance comparison",
    DistributeHistory: "Distribute history",
    CollectionSystem: "C2 Credit Middle Platform",
    callRecords: "call records",
    PaymentCodeInquire: "Payment code Inquire",
    salaryReport: "salary report",
    Applyapprove: "Apply approve",
    TelemarketingTicketSystem: "Telemarketing ticket system",
    OCRannotationmanagement:'OCR annotation management',
    OCRTicketList:"OCR Ticket List",
    OCRlist:'OCR list',
    WhatsAppManage:'whatsAPPManage',
    WhatsAppLogin:'whatsAPP account management',
    WhatsAppChat:'whatsAPPChat',
    CorpusAnnotation:'Corpus Annotation',
    CorpusAnnotationDetail:'Corpus Annotation Details',

    CorpusAnnotationList:'Corpus Annotation List',
    StaffBasicProperty: "Staff Basic Property",
    StaffCombProperty: "Staff Combination Property",
    Dashboard: "Dashboard",
    DashboardScreen: "Dashboard Screen",
    LoggingManagement: "Logging Management",
    SystemOperationLog: "System Operation Log",
    ThirdPartyRequestLog: "Third Party Request Log",

    pageTips: 'There are log records for any behavior, please do not use company data privately, private data will be strictly held accountable!'
  },
  lang: {
    Spanish: "Español",
    Chinese: "中文",
    English: "English",
    Vietnam: "Tiếng Việt",
    indo:"bahasa Indonesia",
    Arabic:' بالعربية ',
  },
  v0703: {
    Caseid: "Case id",
    TicketOperate: "Ticket operate",
    PleaseEnterOrSelectRole: "Please enter or select role",
    CreationTime: "Create Time",
    LoadAttributesName: "Load attributes name",
    PleaseEnterOrSelectAnAttributes: "Please enter or select an attributes",
    LoadAttributesNumber: "Load attributes number",
    LoadAttributesDescription: "Load attributes description",
    LoadAttributesType: "Load attributes type",
    CombinedPropertyName: "Combined property name",
    NumericalValue: "Numerical value",
    Options: "Options",
    Time: "Time",
    CrowdOrder: "Crowd order",
    Save: "Save",
    PleaseEnter: "Please enter",
    TicketUnassign: "Ticket unassign",
    ViopNumberUnassign: "Viop number unassign",
    NewAddition: "New addition",
    TicketAssignStaff: "Ticket assign staff",
    TicketStaffId: "Ticket staff id",
    TicketUnassignTime: "Ticket unassign time",
    ByDay: "Search By day",
    Hour: "Search By hour",
    ParameterValue: "Parameter value"
  },
  v0707: {
    FirstsubsequentLoan: "First subsequent loan",
    FirstLoan: "First loan",
    Reloan: "Reloan",
    Yes: "Yes",
    No: "No"
  },
  annotation: {
    AnnotationManagement: "标注管理",
    AnnotationTicketManagement: "标注工单管理",
    AnnotationTicketList: "标注工单列表",
  },
  smsPushTask: {
    multilingualTitle: "Multilingual title",
    multilingualContent: "Multilingual content",
    multilingualStatus: "Multilingual status",
    label: "Label",
    state: "State",
    addMultilingual: "Add multiple languages",
    multilingualDesc: "Multilingual description",
    relateSmsTask: "Associate SMS task",
    relatePushTask: "Associate push task",
    operator: "operator",
    changeState: "Modify status",
    editContent: "Edit content",
    addMultilingualContent: "Add multilingual content",
    selectLanguage: "Choose language",
    varLibrary: "Variable library",
    multiContentManage: "Multilingual Content Management",
  },
  ...enLocale,
  ...performanceEn,
  ...JSON.parse(trans),
  ...JSON.parse(hom),
  ...langEn,
  ...fhbLangEn,
  ...wrhLangEn,
  ...lxyLangEn,
  ...DyLangEn,
  ...lssLangEn,
};

export default en;
